import { createContext, useContext } from "react";

const DemandStudioContext = createContext(null);

const DemandStudioProvider = ({ children, value }) => {
  return (<DemandStudioContext.Provider value={value}>
    {children}
  </DemandStudioContext.Provider>
);
}

const useDemandStudioContext = () => {
  const context = useContext(DemandStudioContext);

  if (!context) {
    throw new Error(
      "useDemandStudioContext must be used within DemandStudioProvider"
    );
  }

  return context;
};

export { DemandStudioProvider, useDemandStudioContext };